import { render, staticRenderFns } from "./keywordCard.vue?vue&type=template&id=5f482071"
import script from "./keywordCard.vue?vue&type=script&lang=js"
export * from "./keywordCard.vue?vue&type=script&lang=js"
import style0 from "./keywordCard.vue?vue&type=style&index=0&id=5f482071&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports